import { MAX_FILE_SIZE_BYTES, ALLOWED_FILE_TYPES } from './constants'

export class ValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ValidationError'
  }
}

/**
 * Validate file type and size
 *
 * @param file - File to validate
 * @throws {ValidationError} If validation fails
 */
export function validateFile(file: File): void {
  // Check file type
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    throw new ValidationError(
      `Tipo de archivo no permitido. Solo se aceptan archivos PDF.`
    )
  }

  // Check file size
  if (file.size > MAX_FILE_SIZE_BYTES) {
    const maxSizeMB = MAX_FILE_SIZE_BYTES / (1024 * 1024)
    throw new ValidationError(
      `El archivo es demasiado grande. Tamaño máximo: ${maxSizeMB} MB`
    )
  }

  // Check if file is empty
  if (file.size === 0) {
    throw new ValidationError('El archivo está vacío')
  }
}

/**
 * Format file size to human-readable string
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

/**
 * Validate PDF file by checking magic number (file signature)
 * PDFs start with %PDF
 */
export async function validatePDFMagicNumber(file: File): Promise<boolean> {
  const header = await file.slice(0, 4).arrayBuffer()
  const bytes = new Uint8Array(header)

  // %PDF in ASCII
  return (
    bytes[0] === 0x25 && // %
    bytes[1] === 0x50 && // P
    bytes[2] === 0x44 && // D
    bytes[3] === 0x46    // F
  )
}
